import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { RefreshCw, Plus, Mail, Wifi, WifiOff, Settings } from 'lucide-react';

interface TipsHeaderProps {
  isLoading: boolean;
  onRefresh: () => void;
  onNewTip: () => void;
  onImapIngest: () => void;
  isMockMode: boolean;
  onToggleMockMode: () => void;
  totalTips: number;
  shownTips: number;
}

export function TipsHeader({
  isLoading,
  onRefresh,
  onNewTip,
  onImapIngest,
  isMockMode,
  onToggleMockMode,
  totalTips,
  shownTips,
}: TipsHeaderProps) {
  return (
    <>
      <div className='flex items-center justify-between mb-4 gap-4'>
        <div>
          <h2 className='text-xl font-medium text-left'>Tip Inbox</h2>
          <p className='text-sm text-muted-foreground text-left'>
            Manage incoming news tips from various sources
            {totalTips > 0 && (
              <span className='ml-2'>
                ({totalTips} total, {shownTips} shown)
              </span>
            )}
          </p>
        </div>
        <div className='flex items-center gap-3'>
          <div className='flex items-center gap-2'>
            {isMockMode ? (
              <>
                <WifiOff className='h-4 w-4 text-orange-500' />
                <span className='text-xs text-orange-600'>Mock mode</span>
              </>
            ) : (
              <>
                <Wifi className='h-4 w-4 text-green-500' />
                <span className='text-xs text-green-600'>Live API</span>
              </>
            )}
          </div>
          <div className='flex items-center gap-1'>
            <Settings className='h-3 w-3 text-muted-foreground' />
            <Switch
              checked={isMockMode}
              onCheckedChange={onToggleMockMode}
              className='scale-75'
            />
          </div>
          <Button
            variant='outline'
            size='sm'
            onClick={onRefresh}
            disabled={isLoading}
            className='gap-1'
          >
            <RefreshCw
              className={`h-3 w-3 ${isLoading ? 'animate-spin' : ''}`}
            />
          </Button>
          <Button size='sm' onClick={onNewTip} className='gap-2'>
            <Plus className='h-4 w-4' />
            New Tip
          </Button>
          <Button
            variant='outline'
            size='sm'
            onClick={onImapIngest}
            className='gap-2'
          >
            <Mail className='h-4 w-4' />
            Check IMAP
          </Button>
        </div>
      </div>
    </>
  );
}
